import { Component, ElementRef, Input, OnDestroy, OnInit, QueryList, ViewChild, ViewChildren } from '@angular/core';
import { MatBottomSheet} from '@angular/material/bottom-sheet';
import { EnquiryComponent } from '../enquiry/enquiry.component';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Router, ActivatedRoute } from '@angular/router';
import { DataService } from '../services/data.service';
import { SearchService } from '../services/search.service';
import { EnquiryStateService } from '../services/enquiry-state.service';
import { LocationMappingService } from '../services/location-mapping.service';
import { checkCookieForUsername, getCookie, slugify } from '../Utils/utils';

@Component({
  selector: 'app-courses',
  templateUrl: './courses.component.html',
  styleUrls: ['./courses.component.css', '../app.component.css']
})
export class CoursesComponent implements OnInit, OnDestroy {
  @ViewChildren('scrollContainer') scrollContainers: QueryList<ElementRef>;
  searchText: string = '';
  private enquiryTimerId: any = null;

  breakpoint: number;
  public category;
  public allData=[];
  public loading=true;
  public filter=false;
  public courseList: { [key: string]: any[] } = {};
  public sortedCategories: string[] = [];

  scrollLeft(index: number) {
    const scrollContainer = this.scrollContainers.toArray()[index].nativeElement;
    if (scrollContainer) {
      scrollContainer.scrollLeft -= 200; // Adjust scroll step as necessary
    }
  }

  // Scroll Right for a specific panel
  scrollRight(index: number) {
    const scrollContainer = this.scrollContainers.toArray()[index].nativeElement;
    if (scrollContainer) {
      scrollContainer.scrollLeft += 200; // Adjust scroll step as necessary
    }
  }

  

  constructor(
    private bottomSheet: MatBottomSheet, 
    private snackbars: MatSnackBar, 
    private router: Router, 
    private route: ActivatedRoute,
    private dataService: DataService, 
    private searchService: SearchService,
    private enquiryStateService: EnquiryStateService,
    private locationMappingService: LocationMappingService
  ) { }

 

  ngOnInit() {

    this.getCourses()
    this.searchService.currentSearchText.subscribe(text => {
      this.searchText = text;
    });
    if(window.innerWidth <= 800 ){
      this.breakpoint=2;
    }
    else{this.breakpoint=4;}

    // Store the timer id so it can be cancelled in ngOnDestroy - otherwise it keeps
    // running after the user navigates away and pops the bottom sheet open on whatever
    // page they land on next (duplicate/leftover enquiry popups).
    this.enquiryTimerId = setTimeout(() => {
      // Only show enquiry if:
      // 1. User hasn't submitted enquiry (no cookie)
      // 2. Enquiry hasn't been shown yet in this session
      if (!this.enquiryStateService.hasEnquiryBeenSubmitted() && 
          !this.enquiryStateService.hasEnquiryBeenShown()) {
        
        // Mark as shown to prevent duplicate popups
        this.enquiryStateService.markEnquiryAsShown();
        
        // Get location from URL if available
        const locationFromUrl = this.getLocationFromUrl();
        
        this.bottomSheet.open(EnquiryComponent,{
          data: {
            source: "course Page",
            location: locationFromUrl
          },
          disableClose: false
        });
      }
    }, 10000);
  }

  ngOnDestroy(): void {
    if (this.enquiryTimerId) {
      clearTimeout(this.enquiryTimerId);
      this.enquiryTimerId = null;
    }
  }
  
  getLocationFromUrl(): string | null {
    const locationParam = this.route.snapshot.paramMap.get('location');
    if (locationParam) {
      // Store the slug and get location
      return this.locationMappingService.getLocationAndStore(locationParam);
    }
    // If no location in URL, check localStorage
    return this.locationMappingService.getStoredLocation();
  }
  

  getCourses(){
    this.loading=true;
    this.dataService.getCourses().subscribe(data=>{
      this.allData=data;
      this.loading=false;
      this.category=new Set(Array.from(this.allData).filter(cat => cat['status']==true).map(item => item['category'].trim()));
      Array.from(this.category).forEach((element:string) => {
        this.courseList[element] = this.allData.filter((item) => item.category === element && item.status === true);
       });
       this.sortedCategories = Object.keys(this.courseList)
       .sort((a, b) => this.courseList[b].length - this.courseList[a].length); 
    })
  }

  filterCourses(category: string): any[] {
    return this.courseList[category].filter((course) =>
      course.courseName.toLowerCase().includes(this.searchText.toLowerCase()) ||
      course.category.toLowerCase().includes(this.searchText.toLowerCase())
    );
  }

  // filterData(data){
  //   // console.log(data)
  //   if(data== undefined){
  //     this.filter=false;
  //     this.courseList=this.allData;
  //   }
  //   else{
  //     this.filter=true;
  //     this.courseList=this.allData.filter(item => item["category"]==data && item["status"]==true);
  //     // console.log(this.courseList);
  //   }
    
  // }

  check(course){

    if(course=="C#"){
      return "../../assets/courses/CSHARP.jpg"
    }
    else{
      return "../../assets/courses/"+course+".jpg"
    }
  }

  onResize(event) {
    //this.breakpoint=window.innerWidth <= 1000 ?1:3;
    if(window.innerWidth <= 1200 && window.innerWidth >= 800)
    {
      this.breakpoint=2;
    }
    else if(window.innerWidth <= 800 ){
      this.breakpoint=1;
    }
    else{this.breakpoint=3;}
  }

  viewCourseDetails(courseName: string) {
  const courseSlug = slugify(courseName);
  this.router.navigate([`/courses/${courseSlug}`]);
}

}
